module.exports = __webpack_public_path__ + "img/hätäsatama_original.85766b82.jpg";